import { ChartData } from '@crm/api'
import { Funnel } from '@crm/components'
import { getColor } from '@crm/components/Charts/utils'
import { useStyles } from '@crm/features/reports/styles'
import { ChartDataItem } from '@crm/features/reports/types'
import { useLocales } from '@shared/locales'
import { Card, Col, Empty, List, Row } from 'antd'
import { useMemo } from 'react'

type Props = {
  isLoading?: boolean
  data?: ChartData
  xAxy?: string
  yAxy?: string
}

export const FunnelChart = ({ data, isLoading, xAxy, yAxy }: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const dataMapping = data?.data as ChartDataItem[]

  const tableData = useMemo(() => {
    if (!data) return
    return dataMapping?.map((item, key) => ({
      text: item[xAxy || 'name'],
      value: item?.Name_count ? item?.Name_count : item[yAxy ?? 'value'],
      color: getColor(key)
    }))
  }, [data, dataMapping, xAxy, yAxy])

  return (
    <Card title={t('menu.sales_funnel')} loading={isLoading}>
      {tableData ? (
        <Row>
          <Col span={12}>
            {tableData?.find((i) => {
              return Number(i?.value) > 0
            }) ? (
              <Funnel dataSource={tableData} />
            ) : (
              <Empty />
            )}
          </Col>

          <Col span={12}>
            <List
              dataSource={tableData}
              renderItem={({ text, value, color }) => (
                <List.Item>
                  <List.Item.Meta
                    title={text}
                    avatar={
                      <div
                        className={styles.listBullet}
                        style={{ background: color }}
                      />
                    }
                  />
                  {value}
                </List.Item>
              )}
            />
          </Col>
        </Row>
      ) : (
        <Empty />
      )}
    </Card>
  )
}
